import { Component, OnInit } from '@angular/core';
import { NgFlowchartStepComponent } from '../../../../../../projects/ng-flowchart/src/lib/ng-flowchart-step/ng-flowchart-step.component';

export type MyForm = {
  input1: string;
};

@Component({
  selector: 'app-form-step3',
  templateUrl: './form-step3.component.html',
  styleUrls: ['./form-step3.component.scss'],
})
export class FormStep3Component
  extends NgFlowchartStepComponent<MyForm>
  implements OnInit
{
  constructor() {
    super();
  }

  override ngOnInit(): void {
    console.log(this.data);
  }
}
